<script>
import SyncTemplatesButton from '../../SyncTemplatesButton.vue';

export default {
  components: {
    SyncTemplatesButton,
  },
  props: {
    inbox: {
      type: Object,
      required: true,
    },
  },
  emits: ['create', 'sync'],
};
</script>

<template>
  <div
    class="flex items-center justify-between p-4 border-b border-n-weak bg-n-solid-1"
  >
    <div>
      <h2 class="text-lg font-semibold text-n-slate-12">
        {{ $t('INBOX_MGMT.SETTINGS_POPUP.HSM_TEMPLATES.TITLE') }}
      </h2>
      <p class="text-sm text-n-slate-11">
        {{ $t('INBOX_MGMT.SETTINGS_POPUP.HSM_TEMPLATES.SUBTITLE') }}
      </p>
    </div>
    <div class="flex items-center gap-2">
      <SyncTemplatesButton :inbox="inbox" @sync="$emit('sync')" />
      <woot-button icon="add" @click="$emit('create')">
        {{ $t('INBOX_MGMT.SETTINGS_POPUP.HSM_TEMPLATES.CREATE.BUTTON') }}
      </woot-button>
    </div>
  </div>
</template>
